import { createAsyncThunk } from '@reduxjs/toolkit';
import createNotification from '../../../utils/createNotification';
import { Profile } from '../models/profile';

export const UpdateProfile = createAsyncThunk(
    'profilesData/updateProfile',
    async (profile: Profile, { getState }: any) => {
        const axios = getState().core.axios;
        try {
            const response = await axios.put(
                `api/Profiles/${profile.id}`,
                profile
            );

            if (response.status === 200) {
                return profile;
            }

            throw new Error('Failed to update profile');
        } catch (error) {
            createNotification(
                'Something went wrong, could not update profile. Please try again.',
                'error'
            );
            throw error;
        }
    }
);
